import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6242ca10")

_pushScopeId("data-v-6242ca10")
const _hoisted_1 = { class: "my-list-folder-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MyListFolderListItem = _resolveComponent("MyListFolderListItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.folderList, (folder) => {
      return (_openBlock(), _createBlock(_component_MyListFolderListItem, {
        key: folder.id,
        imageUrl: folder.image,
        name: folder.name,
        numberOfItems: folder.numberOfItems,
        folderId: folder.id,
        isAll: _ctx.isAll(folder.id),
        checkedId: _ctx.checkedId,
        onSelectCheck: _ctx.selectCheck
      }, null, 8, ["imageUrl", "name", "numberOfItems", "folderId", "isAll", "checkedId", "onSelectCheck"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})